<template>
	<svg viewBox="0 0 7 10" fill="none" :style="transform" xmlns="http://www.w3.org/2000/svg">
		<path d="M1.54419 1L6.00006 5L1.54419 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
</template>

<script>
export default {
  name : 'icon-chevron',

  props : {
    // 'up' | 'right' | 'down' | 'left'
    // defaults to 'right'
    direction : String
  },

  computed : {
    transform() {
      let deg = 0;
      switch ( this.direction ) {
        case 'up':
          deg = 270;
          break;
        case 'left':
          deg = 180;
          break;
        case 'down':
          deg = 90;
          break;
        default:
          deg = 0;
      }

      return `transform: rotate(${deg}deg);`;
    }
  }
};
</script>
